export default function hasOutstandingCombatantAction(
  combatant = {},
  currentAction = 0,
  maxCA = 0,
) {
  if (!combatant || typeof combatant !== 'object') {
    return false
  }

  if (Number(combatant.counters || 0) > 0) {
    return true
  }

  const resolvedCurrentAction = Number(currentAction || 0)

  if (resolvedCurrentAction > 0) {
    const actionName = combatant[`ca_name${resolvedCurrentAction}`]
    const actionType = combatant[`ca_type${resolvedCurrentAction}`]

    if (actionName === 'pending' || actionName === 'delay' || actionType === 'marker') {
      return true
    }
  }

  for (let actionNum = 1; actionNum <= Number(maxCA || 0); actionNum++) {
    if (combatant[`ca_name${actionNum}`] === 'delay') {
      return true
    }
  }

  return false
}
